import client from './client';

export const getAlertsPaginated = (params) =>
  client.get('/alerts', { params }).then((r) => r.data);

export const markAlertRead = (uuid) =>
  client.patch(`/alerts/${uuid}/read`).then((r) => r.data);

export const markAllAlertsRead = () =>
  client.post('/alerts/mark-all-read').then((r) => r.data);

export const checkAlerts = (businessUuid) =>
  client.post(`/alerts/check/${businessUuid}`).then((r) => r.data);
